module.exports = __webpack_public_path__ + "static/media/rose.c361c87a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/rose.jpg
// module id = 540
// module chunks = 0